import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-logout-icon]',
  template: `
    <svg:path
      d="M12.4668 1.48242C13.6442 1.36469 14.666 2.28941 14.666 3.47266V12.5264C14.6658 13.7094 13.644 14.6333 12.4668 14.5156L8.4668 14.1162C7.44459 14.0138 6.66602 13.1534 6.66602 12.126V11.333C6.66602 10.9648 6.96482 10.666 7.33301 10.666C7.70114 10.6661 8 10.9649 8 11.333V12.126C8 12.4684 8.25895 12.7548 8.59961 12.7891L12.5996 13.1895C12.9919 13.2287 13.3328 12.9206 13.333 12.5264V3.47266C13.333 3.07824 12.9921 2.77032 12.5996 2.80957L8.59961 3.20898C8.25892 3.24317 8 3.53062 8 3.87305V4.66602C7.99998 5.03415 7.70113 5.33294 7.33301 5.33301C6.96483 5.33301 6.66603 5.03419 6.66602 4.66602V3.87305C6.66602 2.84569 7.4446 1.98525 8.4668 1.88281L12.4668 1.48242ZM4.19434 4.86133C4.45469 4.60098 4.87735 4.60098 5.1377 4.86133C5.39789 5.12161 5.39781 5.54337 5.1377 5.80371L3.60938 7.33301H10.666C11.0341 7.33301 11.3329 7.63097 11.333 7.99902C11.333 8.36721 11.0342 8.66602 10.666 8.66602H3.60938L5.1377 10.1943C5.39805 10.4547 5.39805 10.8773 5.1377 11.1377C4.87734 11.3979 4.45465 11.398 4.19434 11.1377L1.52832 8.4707C1.26801 8.21039 1.26809 7.78868 1.52832 7.52832L4.19434 4.86133Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
